<template>
  <div v-if="!dsf.global.$isMobile" class="ds-empty-data">
    <DsfIcon :name="icon"></DsfIcon>
    <span>{{text}}</span>
  </div>
  <van-empty v-else :image="image" :description="description" :image-size="imageSize"/>
</template>
<script>
export default {
  name: "DsfEmptyData",
  props: {
    text: {
      type: String,
      default: "暂无数据"
    },
    icon: {
      type: String,
      default: "no-data"
    },
    image: {
      // 属性名和van-empty一致
      type: String,
      default: require('_platform/assets/styles/themes/img/empty-image-default.png')
    },
    description: {
      // 属性名和van-empty一致
      type: String,
      default: "暂无数据"
    },
    imageSize: {
      // 属性名和van-empty一致
      type:[Number,String,Array],
      default:""
    }
  },
  data() {
    return {};
  },
  computed: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  methods: {},
  beforeDestroy() {},
  destroyed() {}
};
</script>